import { withTheme } from '@buoyhealth/common.buoy-theme';
import Card from './Card';
import Dialog from './Dialog';
import { DEFAULT_TIPPING_CONFIG, ISurveyConfig } from '@buoyhealth/common.buoy-user-feedback';

export interface IEmailTranscriptProps {
  variant: 'card' | 'dialog';
  surveyConfig?: ISurveyConfig;
  interview: string;
  isVisible: boolean;
  handleCardSubmit?: () => void;
  shouldShowTipping?: boolean;
  tippingConfig?: typeof DEFAULT_TIPPING_CONFIG;
  stripeApiKey?: string;
}

const EmailTranscript = (props: IEmailTranscriptProps) => {
  const {
    handleCardSubmit,
    isVisible,
    surveyConfig,
    variant,
    interview,
    shouldShowTipping,
    tippingConfig,
    stripeApiKey,
  } = props;
  if (variant === 'card') {
    return (
      <Card
        title="Don’t lose your results! Get a copy of your visit sent to your email."
        interview={interview}
        isVisible={isVisible}
        handleCardSubmit={handleCardSubmit}
      />
    );
  }

  return (
    <Dialog
      surveyConfig={surveyConfig as any}
      interview={interview}
      isVisible={isVisible}
      shouldShowTipping={shouldShowTipping}
      tippingConfig={tippingConfig}
      stripeApiKey={stripeApiKey}
    />
  );
};

export default withTheme(EmailTranscript);
